import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom"
import LoginPage from "./pages/LoginPage/LoginPage"
import AuthProvider from "./components/AuthProvider"
import PrivateRoute from "./components/PrivateRoute"
import DashboardProduct from "./pages/Dashboards/DashboardProduct"
import DashboardProvidence from "./pages/Dashboards/DashboardProvidence"
import DashboardReport from "./pages/Dashboards/DashboardReport"
import DashboardMaintenance from "./pages/Dashboards/DashboardMaintenance" 
import { SearchProvider } from "./context/KeywordSearchContext"
import { MaintenanceViewProvider } from "./context/MaintenanceViewContext" 

const App = () => {

    return (
        <Router>
            <AuthProvider>
                <SearchProvider>
                    <Routes>
                        <Route path="/login" element={<LoginPage />}/>
                        <Route element={<PrivateRoute />}>
                            <Route path="*" element={<Navigate to="/dashboard/products" replace/>}/>
                            <Route path="/dashboard/products" element={<DashboardProduct />} />
                            <Route path="/dashboard/provinces" element={<DashboardProvidence/>}/>
                            <Route path="/dashboard/report" element={<DashboardReport/>}/>

                            <Route path="/dashboard/products/CatGeneric" element={<DashboardProduct />} />
                            <Route path="/dashboard/products/CotscoProd" element={<DashboardProduct />} />
                            <Route path="/dashboard/products/GenericProd" element={<DashboardProduct />} />
                            <Route path="/dashboard/maintenance" element={<MaintenanceViewProvider><DashboardMaintenance/></MaintenanceViewProvider>}/>
                        </Route>
                    </Routes>
                </SearchProvider>
            </AuthProvider>
        </Router>        
    )
}

export default App